<template>
  <jr-button class="send-btn" type="primary" @click="print"> 出力 </jr-button>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { AxiosResponse } from 'axios'
import JrButton from '@/components/jr-parts/JrButton.vue'
import { fileDownload } from '@/services/file'
import { PrintCreateRequest } from '@/requests/schedule'
import { SchedulePrintResponse, SchedulePrintRequest } from '@/api'

/**
 * 日程出力ボタン
 */
export default defineComponent({
  name: 'SchedulePrint',
  components: {
    JrButton,
  },
  props: {
    messageId: {
      type: Number,
      required: false,
      default: null,
    },
    applicantNumber: {
      type: String,
      required: false,
      default: null,
    },
  },
  setup(props) {
    /**
     * 出力
     */
    const print = async () => {
      // メッセージID取得
      const requestParam: SchedulePrintRequest = {
        message_id: props.messageId,
      }
      const request = new PrintCreateRequest(requestParam)
      await request.exec()

      if (request.success) {
        const { data } = request.getResponse() as AxiosResponse<SchedulePrintResponse>
        fileDownload(data, props.applicantNumber + '（JR日程調整）.xlsx')
      }
    }

    return {
      print,
    }
  },
})
</script>
